import { Reportdata } from '../model/reportdata';
export class Folderdata {

    id: string;
    title: string;
    reports: Reportdata[];
    searchPath: string;
    collapsed: boolean;
    folder: boolean;
    user: string;

    constructor(id: string, title: string, reports: Reportdata[], searchPath: string, collapsed: boolean, folder: boolean,user?: string) {
        this.id = id;
        this.title = title;
        this.reports = reports;
        this.searchPath = searchPath;
        this.collapsed = collapsed;
        this.folder = folder;
        this.user = user;
    };

}


// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-admin/model/folderdata.ts